import { PublicRecommendationItemDto } from '../../dto/recs.dto';
import { AdSlotContainerItem } from '../../entities/ad-slot-container-item';
import { defineOwnProperties } from '../../utils/object';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class AdSlotContainerItemResolver {
  public resolve (response: PublicRecommendationItemDto): AdSlotContainerItem {
    const adSlotContainerItem = new AdSlotContainerItem();

    // Inject readonly properties
    defineOwnProperties(adSlotContainerItem, {
      id: response.id,
      title: response.title,
      subtitle: response.subtitle,
      publicationName: response.publicationName,
      publicationAbbreviatedName: response.publicationAbbreviatedName,
      publicationDate: response.publicationDate,
      campaignId: response.campaignId,
      publicationId: response.publicationId,
      url: response.url,
      clickUrl: response.clickUrl,
      impressionUrl: response.impressionUrl,
      linkingType: response.linkingType,
      authors: response.authors,
      creativeType: response.creativeType,
      creative: response.creative,
    });

    return adSlotContainerItem;
  }
}
